import {MarkupNodeType, HTML_TAG_LINE_BREAK} from '#src/constants.js';
import {createHtmlTag, toBase64} from '#src/helper.js';
import {SkipType} from '#src/processing-context.js';

const convertCommand = isMarkdown => ({options, text}) => {
  options.skipType = SkipType.SkipCode;

  const dataset = {'data-source': toBase64(text)};

  return createHtmlTag(MarkupNodeType.Command, dataset, {isMarkdown});
};

function convertEmDash({options}) {
  options.skipType = SkipType.NoSkip;

  return '—';
}

function convertEnDash({options}) {
  options.skipType = SkipType.NoSkip;

  return '–';
}

function convertCSpoiler({matchStart, options, text}) {
  const {title1, title2} = matchStart.groups || {};

  const title = title1 || title2;

  options.skipType = SkipType.NoSkip;
  options.op = createHtmlTag(
    MarkupNodeType.CollapsibleSpoiler,
    title ? {'data-title': toBase64(title)} : {},
    {isNonClosing: true}
  );
  options.cl = '</div>';

  return text;
}

function convertTooltip({matchStart, options, text}) {
  const {value1, value2} = matchStart.groups;

  const value = value1 || value2;

  options.skipType = SkipType.NoSkip;
  options.op = createHtmlTag(MarkupNodeType.Tooltip, {'data-tooltip': toBase64(value)}, {isNonClosing: true});
  options.cl = '</div>';

  return text;
}

function convertQuotation({matchEnd, matchStart, options, text}) {
  options.skipType = SkipType.NoSkip;

  if (matchStart[1] === '\n') {
    options.op = HTML_TAG_LINE_BREAK;
  }

  options.op += createHtmlTag(MarkupNodeType.Quotation, {}, {isMarkdown: true, isNonClosing: true});
  options.cl = '</div>';

  if (matchEnd[0] === '\n') {
    options.cl += HTML_TAG_LINE_BREAK;
  }

  return text;
}

function checkQuotationNotInterrupted(info, matchs, matche) {
  if (info.isIn(matchs.index, matche.index - matchs.index)) {
    return false;
  }

  if (matchs.index === 0) {
    return true;
  }

  if (info.text.substr(matchs.index - 1, 1) === '\n') {
    return true;
  }

  return info.isIn(matchs.index - HTML_TAG_LINE_BREAK.length, HTML_TAG_LINE_BREAK.length, SkipType.SkipHtml) &&
    (info.text.substr(matchs.index - HTML_TAG_LINE_BREAK.length, HTML_TAG_LINE_BREAK.length) === HTML_TAG_LINE_BREAK);
}

export default [{
  cl: null,
  convert: convertEmDash,
  op: '----',
  priority: 2400
}, {
  cl: null,
  convert: convertEnDash,
  op: '--',
  priority: 2600
}, {
  cl: '[/cspoiler]',
  convert: convertCSpoiler,
  nestable: true,
  op: '[cspoiler]',
  priority: 4300
}, {
  cl: '[/cspoiler]',
  convert: convertCSpoiler,
  nestable: true,
  op: /\[cspoiler\s+title=(?:'(?<title1>[^']*)'|"(?<title2>[^"]*)")\s*\]/giu,
  priority: 4400
}, {
  cl: '[/tooltip]',
  convert: convertTooltip,
  nestable: true,
  op: /\[tooltip\s+value=(?:'(?<value1>[^']*)'|"(?<value2>[^"]*)")\s*\]/giu,
  priority: 4500
}, {
  check: checkQuotationNotInterrupted,
  cl: /\n|$/giu,
  convert: convertQuotation,
  op: '>',
  priority: 4900
}, {
  cl: ']]',
  convert: convertCommand(true),
  op: '[[',
  priority: 4851
}, {
  cl: '[/command]',
  convert: convertCommand(false),
  op: '[command]',
  priority: 4852
}];
